import React from "react";

export default function LineItemsTable({ items = [], money }) {
  return (
    <div className="jt-document-section jt-doc-line-items">
      <div className="jt-doc-section-title">Scope of Work</div>

      <table className="jt-document-table jt-doc-items-table">
        <thead>
          <tr>
            <th>Description</th>
            <th>Qty</th>
            <th>Unit Price</th>
            <th>Tax</th>
            <th>Line Total</th>
          </tr>
        </thead>

        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={5} className="jt-doc-empty-cell">
                No items listed.
              </td>
            </tr>
          ) : (
            items.map((it) => (
              <tr key={it.id}>
                <td className="jt-doc-item-description">
                  {it.description || "—"}
                </td>
                <td className="jt-doc-number-cell">
                  {Number(it.qty || 0).toFixed(2)}
                </td>
                <td className="jt-doc-number-cell">
                  {money(it.unit_price)}
                </td>
                <td className="jt-doc-number-cell">
                  {(Number(it.tax_rate || 0) * 100).toFixed(2)}%
                </td>
                <td className="jt-doc-number-cell jt-doc-line-total">
                  {money(it.line_total)}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
